import { make } from './TooltipIcon.gen'

type TooltipIconProps = React.ComponentProps<typeof make>

const TooltipIcon = make as React.FunctionComponent<TooltipIconProps>

export { TooltipIcon, type TooltipIconProps }
